<script lang="ts">
  import ButtonBase from "$components/+blocks/Button/internal/ButtonBase.svelte";
  import IconButtonBase from "$components/+blocks/IconButton/internal/IconButtonBase.svelte";
  import { sharedButtonClasses } from "$components/+blocks/Button/Button.svelte";
  import { ThumbsUp, ThumbsDown } from "$components/+blocks/OVIcon";
  import { tooltip } from "app/actions/tooltip";
  import cx from "classnames";

  export let isPositive = false;
  export let clicked = false;
  export let hideLabel = false;
  export let customIconSize: string | undefined = undefined;
  export let a11yLabel: string = isPositive ? "Yes" : "No";

  const activeButtonStyle = {
    positive: cx(
      "border bg-emerald-100 text-emerald-500 dark:bg-emerald-500/10 dark:text-emerald-300",
      { "border-transparent bg-emerald-100 text-emerald-500": hideLabel }
    ),
    negative: cx("border bg-red-100 text-red-500 dark:bg-red-500/10 dark:text-red-300", {
      "border-transparent bg-red-100 text-red-500": hideLabel,
    }),
  };

  const defaultStyle =
    "hover:bg-black/5 text-neutral-400 hover:text-gray-600 dark:hover:bg-white/10 dark:hover:text-gray-300 border border-transparent";

  $: buttonStyle = !clicked
    ? defaultStyle
    : isPositive
      ? activeButtonStyle.positive
      : activeButtonStyle.negative;
</script>

<span class="contents">
  {#if hideLabel}
    <span use:tooltip={{ content: a11yLabel }}>
      <IconButtonBase
        {a11yLabel}
        {customIconSize}
        class={cx(sharedButtonClasses, buttonStyle, "rounded-md p-1")}
        icon={isPositive ? ThumbsUp : ThumbsDown}
        disabled={clicked}
        on:click
      />
    </span>
  {:else}
    <ButtonBase
      class={cx(
        sharedButtonClasses,
        buttonStyle,
        "h-[28px] w-auto rounded-[5px] border-transparent px-2 text-sm md:text-[13px]"
      )}
      label={isPositive ? "Yes" : "No"}
      iconLeft={isPositive ? ThumbsUp : ThumbsDown}
      disabled={clicked}
      on:click
    />
  {/if}
</span>
